import { shallowMount, createLocalVue } from "@vue/test-utils";
import PdpXsellCarousel from './PdpXsellCarousel';
import mockAxios from 'axios';

const localVue = createLocalVue();

let getRecommendationsSpy = jest.spyOn(PdpXsellCarousel.methods, 'getRecommendations');
let slickNextMock = jest.fn();
let slickPrevMock = jest.fn();

const createWrapper = () => {
  return shallowMount(PdpXsellCarousel, {
    localVue,
    propsData: { productCode: '4NMG' },
    stubs: {
      'slick': {
        template: '<div></div>',
        methods: {
          next: slickNextMock,
          prev: slickPrevMock
        }
      }
    }
  });
};

const recs = [{
  id: 1,
  url_key: 'prod-key-1',
  imagery: {
    standard: {
      url: 'https://mr-cdn.imgix.net/content/images/2019/4/prod-1',
      alt_text: 'Prod 1'
    }
  }
}, {
  id: 2,
  url_key: 'prod-key-2',
  imagery: {
    standard: {
      url: 'https://mr-cdn.imgix.net/content/images/2019/4/prod-2',
      alt_text: 'Prod 2'
    }
  }
}, {
  id: 3,
  url_key: 'prod-key-3',
  imagery: {
    standard: {
      url: 'https://mr-cdn.imgix.net/content/images/2019/4/prod-3',
      alt_text: 'Prod 3'
    }
  }
}];

describe('PdpXsellCarousel', () => {
  beforeEach(() => {
    getRecommendationsSpy.mockClear();
    slickNextMock.mockClear();
    slickPrevMock.mockClear();
    mockAxios.get.mockImplementationOnce(() => Promise.resolve({ data: recs }));
  });

  test('general snapshot', () => {
    let wrapper = createWrapper();
    expect(wrapper.html()).toMatchSnapshot();
  });

  test('carousle next click', () => {
    let wrapper = createWrapper();
    wrapper.setMethods({
      next: jest.fn(),
      prev: jest.fn()
    });

    wrapper.find('.right-nav').trigger('click');
    expect(wrapper.vm.next).toHaveBeenCalledTimes(1);
  });

  describe('methods', () => {
    describe('next', () => {
      test('call next from slick', () => {
        let wrapper = createWrapper();
        wrapper.setData({ xsellRecommendations: recs });
        wrapper.vm.next();
        expect(slickNextMock).toHaveBeenCalledTimes(1);
      });
    });

    describe('prev', () => {
      test('call prev from slick', () => {
        let wrapper = createWrapper();
        wrapper.setData({ xsellRecommendations: recs });
        wrapper.vm.prev();
        expect(slickPrevMock).toHaveBeenCalledTimes(1);
      });
    });
  });

  test('mounted', () => {
    createWrapper();
    expect(getRecommendationsSpy).toHaveBeenCalledTimes(1);
  });
});
